module.exports = __webpack_public_path__ + "fonts/a7e2bbd1-4a46-45fa-9e36-1a26e482c098.b819669.woff";